import { FC, useContext } from 'react';

import { Button, Tooltip } from '@smartshell/ui-kit';

import { AuthContext } from 'auth';
import { ESubscription, FeaturesContext } from 'features';
import { LocalizationContext } from 'localization';

import s from './HostsAddButtons.module.scss';

type HostsAddButtonsProps = {
  hostsCount: number;
  addHost: () => void;
  addGroup: () => void;
  isGroups?: boolean;
};
export const HostsAddButtons: FC<HostsAddButtonsProps> = ({
  hostsCount,
  addGroup,
  addHost,
  isGroups,
}) => {
  const { t } = useContext(LocalizationContext);
  const { host_count: availableHostCount, subscription } =
    useContext(FeaturesContext);

  const {
    data: { permissions },
  } = useContext(AuthContext);

  if (!permissions?.has('host_manage')) return null;

  const DISABLED_TOOLTIP = t(
    isGroups
      ? subscription === ESubscription.FREE
        ? 'hosts.max.free'
        : 'hosts.max'
      : 'computers.buttons.disabled.tooltip'
  );

  return (
    <div className={s.container}>
      {hostsCount >= availableHostCount ? (
        <Tooltip contentClassName={s.tooltip} content={DISABLED_TOOLTIP}>
          <Button
            variant="secondary"
            onClick={addHost}
            iconName={'CirclePlusIcon'}
            disabled={hostsCount >= availableHostCount || !isGroups}
            className={s.button_add}
          >
            {t('hosts.add')}
          </Button>
        </Tooltip>
      ) : (
        <Button
          variant="secondary"
          onClick={addHost}
          iconName={'CirclePlusIcon'}
          disabled={hostsCount >= availableHostCount}
        >
          {t('hosts.add')}
        </Button>
      )}

      <Button onClick={addGroup} iconName={'CirclePlusIcon'}>
        {t('group.create')}
      </Button>
    </div>
  );
};
